import React, { useState, useEffect, useRef  } from 'react';
import { MdDisabledByDefault } from "react-icons/md";
import { FcOk } from "react-icons/fc";
import { FaCamera } from 'react-icons/fa';
import { getimagesReflex, uploadimagesReflex, reflextupdate, getReflex } from '../../api/api';
import { useLocation, useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
import Modal from 'react-modal';
import { useMediaQuery } from 'react-responsive';
import atos from '../../assets/atos-logo.svg';
import '../../styles/Buttons.css';
import '../../styles/Texts.css';
import '../../styles/Alinhamento.css';
import '../../styles/Imagens.css';
import "react-widgets/styles.css";

function EditarReflex() {
    const location = useLocation();
    const { user, equipamentos } = location.state || {};
    const navigate = useNavigate();
    const isBigScreen = useMediaQuery({ query: '(min-width: 481px)' });
    const [isChecked, setIsChecked] = useState(equipamentos.encontrado || false);
    const [equipamento, setEquipamento] = useState({});
    const [isCameraModalOpen, setIsCameraModalOpen] = useState(false);
    const [isWebcamModalOpen, setIsWebcamModalOpen] = useState(false);
    const [selectedCamera, setSelectedCamera] = useState();
    const [imageUrls, setImageUrls] = useState([]);
    const webcamRef = useRef(null);

    useEffect(() => {
        if (equipamentos === undefined) {
            navigate('/');
        } else {
            setEquipamento({
                hostname: equipamentos.hostname || '',
                numero_serie: equipamentos.numero_serie || '',
                fan: equipamentos.fan || '',
                modelo: equipamentos.modelo || '',
                oficina_zona_taller: equipamentos.oficina_zona_taller || '',
                pilar: equipamentos.pilar || '',
                apellidos_titular_nombre_titular: equipamentos.apellidos_titular_nombre_titular || '',
                grupo: equipamentos.grupo || '',
                windows_build: equipamentos.windows_build || '',
                estado: equipamentos.estado || '',
                utilizacion: equipamentos.utilizacion || '',
                tipo_ci_tipo_puesto: equipamentos.tipo_ci_tipo_puesto || '',
                direccion_ip: equipamentos.direccion_ip || '',
                na: equipamentos.na || '',
                centro_produccion: equipamentos.centro_produccion || '',
                comentarios: equipamentos.comentarios || '',
                fecha_creacion: equipamentos.fecha_creacion || '',
                verificacao_etiqueta: equipamentos.verificacao_etiqueta || '',
                respostas_psav3: equipamentos.respostas_psav3 || '',
                tipo_uso: equipamentos.tipo_uso || '',
                numero_inventario: equipamentos.numero_inventario || '',
                idade_meses: equipamentos.idade_meses || '',
                encontrado: equipamentos.encontrado || false,
                alterado_em: equipamentos.alterado_em || '',
            });
            fetchImages(equipamentos.pk);
        }
    }, [equipamentos, navigate]);
    const videoConstraints = {facingMode: { exact: "environment" }};
    
    const fetchImages = async (index) => {
        try {
            const response = await getimagesReflex(index);            
            setImageUrls(response.images || []);
        } catch (error) {
            console.error('Error fetching images:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        let formattedValue = value;
    
        if (name === 'dataFieldName') { // Substitua 'dataFieldName' pelo nome do campo de data real
            const date = new Date(value);
            formattedValue = date.toISOString(); // Inclui milissegundos e o sufixo Z
        }
    
        setEquipamento(prevState => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleCheckboxChange = () => {
        setIsChecked(prev => !prev);
        setEquipamento(prevState => ({
            ...prevState,
            encontrado: !prevState.encontrado
        }));
    };
 
    const fetchUsers = async (updatedEquipamento) => {
        try {
            await reflextupdate(user, equipamentos.pk, updatedEquipamento);
            alert('Equipamento atualizado com sucesso.');
            const response = await getReflex();
            const equipamento = response.map((r) => ({
                ...r.fields,
                pk: r.pk
            }));    
            localStorage.setItem('equipamentosR', JSON.stringify(equipamento)); 
        } catch (error) {            
            alert('Ocorreu um erro ao atualizar o equipamento. Por favor, entre em contato com o administrador do sistema.');
        }
    };

    const handleSave = async () => {
        await fetchUsers(equipamento);        
    };

    const handleOpenCameraModal = () => {
        setIsCameraModalOpen(true);
    };

    const handleOpenWebcamModal = (cameraIndex) => {               
        setSelectedCamera(cameraIndex);        
        setIsCameraModalOpen(false);
        setIsWebcamModalOpen(true);
    };

    const handleTakePhoto = async (slot) => {
        setIsWebcamModalOpen(false);
        const imageSrc = webcamRef.current.getScreenshot();       
        const filename = `${equipamentos.nome}_${slot}.jpg`;
        await uploadimagesReflex(equipamentos.pk,imageSrc, slot, filename );
        await fetchImages(equipamentos.pk)
        setIsCameraModalOpen(true);             
    };

    const handleTakePhotoCancel = () => {
        setIsWebcamModalOpen(false); 
        setIsCameraModalOpen(true) 
    };

    const handleOpenWebcamModalCancel = () => {              
        setIsCameraModalOpen(false);
        setIsWebcamModalOpen(false);
    };

    return (
        <>          

            <main>
                <p></p>
                <div className='icon-container'>
                    <div className='checkbox-container' onClick={handleCheckboxChange}>
                        {isChecked ? <FcOk size={50} /> : <MdDisabledByDefault size={50} />}
                    </div>
                    <div className='checkbox-container' onClick={handleOpenCameraModal}>
                        <FaCamera size={50} onClick={handleOpenCameraModal} />
                    </div>
                </div>

                <div className='conteudo-principal'>
                    <div className='equipamento-barra-alinhamento'>
                        <div className='equipamento-conteudo'>
                            {Object.entries(equipamento).map(([key, value]) => {
                                if (key === 'encontrado') return null;
                                let inputElement;
                                if (key === 'alterado_em') {
                                    const formattedValue = value ? new Date(value).toISOString().slice(0, 16) : '';
                                    inputElement = (<input type='datetime-local' name={key} value={formattedValue} disabled />);
                                } else if (key === 'fecha_creacion') {
                                    const formattedValue = value ? new Date(value).toISOString().slice(0, 16) : '';
                                    inputElement = (<input type='datetime-local' name={key} value={formattedValue} onChange={handleInputChange} />);
                                } else {
                                    inputElement = (<input type='text' name={key} value={value} onChange={handleInputChange} />);
                                }
                                return (
                                    <div className='equipamento-item' key={key}>
                                        <label>{key.charAt(0).toUpperCase() + key.slice(1)}:</label>
                                        {inputElement}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <button className='button-editar-perfil-usuario Atos-logo' title="Salvar Alteração" onClick={handleSave}>Salvar</button>
                    <button className='button-editar-perfil-usuario Atos-logo' title="Voltar" onClick={() => navigate('/reflex', { state: { user } })}>Voltar</button>

                </div>
                <Modal
                    isOpen={isCameraModalOpen}
                    onRequestClose={() => setIsCameraModalOpen(false)}
                    contentLabel="Select Camera"
                    className='conteudo-principal'
                    overlayClassName="modal-overlay"
                    style={{
                        content: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            maxHeight: '100vh',                            
                            margin: 'auto',
                            padding: '20px',
                        },
                    }}
                >
                <div className='camera-icons-container'>
                    {imageUrls.map((img, index) => (
                        <img
                            key={index}
                            src={img.image}
                            alt={`Imagem carregada ${index + 1}`}
                            style={{ width: 170, height: 170 }}
                            onClick={() => handleOpenWebcamModal(index)}
                        />
                    ))}
                </div>
                <div className='camera-icons-container'>
                    <button
                        className='button-editar-perfil-usuario Atos-logo'
                        title="Voltar"
                        onClick={handleOpenWebcamModalCancel}
                        >
                        Voltar
                    </button> 
                </div>          
                </Modal>

            </main>
            <Modal
                    isOpen={isWebcamModalOpen}
                    onRequestClose={() => setIsWebcamModalOpen(false)}
                    contentLabel="Capture Photo"
                    className='camera-icons-container'
                    overlayClassName="overlay"                    
                    >
                    <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={videoConstraints}
                        style={{ width: 450, height: 450 }}
                    />
                    <div className="button-container">
                        <button className='button-editar-perfil-usuario Atos-logo' title="Tirar foto" onClick={() => handleTakePhoto(selectedCamera)}>Salvar Foto</button>
                        <button className='button-editar-perfil-usuario Atos-logo' title="Cancelar" onClick={handleTakePhotoCancel}>Cancelar</button>
                    </div>
            </Modal>
        </>
    );
}

export default EditarReflex;